module.exports = __webpack_public_path__ + "static/img/topImage.d5dfadad.png";